module.exports = __webpack_public_path__ + "static/Juliette0-46295f8a25b83ae47c54409117c5bd6b.jpg";